function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { combineTransactionSteps, getChangedRanges, findChildrenInRange, getMarksBetween, getAttributes, Mark, mergeAttributes } from '@tiptap/core';
import { find, registerCustomProtocol, reset } from 'linkifyjs';
import { Plugin, PluginKey } from '@tiptap/pm/state';

function autolink(options) {
  return new Plugin({
    key: new PluginKey('autolink'),
    appendTransaction: function appendTransaction(transactions, oldState, newState) {
      var docChanges = transactions.some(function (transaction) {
        return transaction.docChanged;
      }) && !oldState.doc.eq(newState.doc);
      var preventAutolink = transactions.some(function (transaction) {
        return transaction.getMeta('preventAutolink');
      });

      if (!docChanges || preventAutolink) {
        return;
      }

      var tr = newState.tr;
      var transform = combineTransactionSteps(oldState.doc, _toConsumableArray(transactions));
      var changes = getChangedRanges(transform);
      changes.forEach(function (_ref) {
        var newRange = _ref.newRange;
        // Now let’s see if we can add new links.
        var nodesInChangedRanges = findChildrenInRange(newState.doc, newRange, function (node) {
          return node.isTextblock;
        });
        var textBlock;
        var textBeforeWhitespace;

        if (nodesInChangedRanges.length > 1) {
          // Grab the first node within the changed ranges (ex. the first of two paragraphs when hitting enter).
          textBlock = nodesInChangedRanges[0];
          textBeforeWhitespace = newState.doc.textBetween(textBlock.pos, textBlock.pos + textBlock.node.nodeSize, undefined, ' ');
        } else if (nodesInChangedRanges.length // We want to make sure to include the block seperator argument to treat hard breaks like spaces.
        && newState.doc.textBetween(newRange.from, newRange.to, ' ', ' ').endsWith(' ')) {
          textBlock = nodesInChangedRanges[0];
          textBeforeWhitespace = newState.doc.textBetween(textBlock.pos, newRange.to, undefined, ' ');
        }

        if (textBlock && textBeforeWhitespace) {
          var wordsBeforeWhitespace = textBeforeWhitespace.split(' ').filter(function (s) {
            return s !== '';
          });

          if (wordsBeforeWhitespace.length <= 0) {
            return false;
          }

          var lastWordBeforeSpace = wordsBeforeWhitespace[wordsBeforeWhitespace.length - 1];
          var lastWordAndBlockOffset = textBlock.pos + textBeforeWhitespace.lastIndexOf(lastWordBeforeSpace);

          if (!lastWordBeforeSpace) {
            return false;
          }

          find(lastWordBeforeSpace).filter(function (link) {
            return link.isLink;
          }) // Calculate link position.
          .map(function (link) {
            return _objectSpread(_objectSpread({}, link), {}, {
              from: lastWordAndBlockOffset + link.start + 1,
              to: lastWordAndBlockOffset + link.end + 1
            });
          }) // ignore link inside code mark
          .filter(function (link) {
            if (!newState.schema.marks.code) {
              return true;
            }

            return !newState.doc.rangeHasMark(link.from, link.to, newState.schema.marks.code);
          }) // validate link
          .filter(function (link) {
            if (options.validate) {
              return options.validate(link.value);
            }

            return true;
          }) // Add link mark.
          .forEach(function (link) {
            if (getMarksBetween(link.from, link.to, newState.doc).some(function (item) {
              return item.mark.type === options.type;
            })) {
              return;
            }

            tr.addMark(link.from, link.to, options.type.create({
              href: link.href
            }));
          });
        }
      });

      if (!tr.steps.length) {
        return;
      }

      return tr;
    }
  });
}

function clickHandler(options) {
  return new Plugin({
    key: new PluginKey('handleClickLink'),
    props: {
      handleClick: function handleClick(view, pos, event) {
        var _a, _b;

        if (event.button !== 0) {
          return false;
        }

        var attrs = getAttributes(view.state, options.type.name);
        var link = event.target;
        var href = (_a = link === null || link === void 0 ? void 0 : link.href) !== null && _a !== void 0 ? _a : attrs.href;
        var target = (_b = link === null || link === void 0 ? void 0 : link.target) !== null && _b !== void 0 ? _b : attrs.target;

        if (link && href) {
          if (view.editable) {
            window.open(href, target);
          }

          return true;
        }

        return false;
      }
    }
  });
}

function pasteHandler(options) {
  return new Plugin({
    key: new PluginKey('handlePasteLink'),
    props: {
      handlePaste: function handlePaste(view, event, slice) {
        var _a, _b;

        var state = view.state;
        var selection = state.selection; // Do not proceed if in code block.

        if (state.doc.resolve(selection.from).parent.type.spec.code) {
          return false;
        }

        var textContent = '';
        slice.content.forEach(function (node) {
          textContent += node.textContent;
        });
        var isAlreadyLink = false;
        slice.content.descendants(function (node) {
          if (node.marks.some(function (mark) {
            return mark.type.name === options.type.name;
          })) {
            isAlreadyLink = true;
          }
        });

        if (isAlreadyLink) {
          return;
        }

        var link = find(textContent).find(function (item) {
          return item.isLink && item.value === textContent;
        });

        if (!selection.empty && options.linkOnPaste) {
          var pastedLink = (link === null || link === void 0 ? void 0 : link.href) || null;

          if (pastedLink) {
            options.editor.commands.setMark(options.type, {
              href: pastedLink
            });
            return true;
          }
        }

        var firstChildIsText = ((_a = slice.content.firstChild) === null || _a === void 0 ? void 0 : _a.type.name) === 'text';
        var firstChildContainsLinkMark = (_b = slice.content.firstChild) === null || _b === void 0 ? void 0 : _b.marks.some(function (mark) {
          return mark.type.name === options.type.name;
        });

        if (firstChildIsText && firstChildContainsLinkMark || !options.linkOnPaste) {
          return false;
        }

        if (link && selection.empty) {
          options.editor.commands.insertContent("<a href=\"".concat(link.href, "\">").concat(link.href, "</a>"));
          return true;
        }

        var tr = state.tr;
        var deleteOnly = false;

        if (!selection.empty) {
          deleteOnly = true;
          tr.delete(selection.from, selection.to);
        }

        var currentPos = selection.from;
        var fragmentLinks = [];
        slice.content.forEach(function (node) {
          fragmentLinks = find(node.textContent);
          tr.insert(currentPos - 1, node);

          if (fragmentLinks.length > 0) {
            deleteOnly = false;
            fragmentLinks.forEach(function (fragmentLink) {
              var linkStart = currentPos + fragmentLink.start;
              var linkEnd = currentPos + fragmentLink.end;
              var hasMark = tr.doc.rangeHasMark(linkStart, linkEnd, options.type);

              if (!hasMark) {
                tr.addMark(linkStart, linkEnd, options.type.create({
                  href: fragmentLink.href
                }));
              }
            });
          }

          currentPos += node.nodeSize;
        });
        var hasFragmentLinks = fragmentLinks.length > 0;

        if (tr.docChanged && !deleteOnly && hasFragmentLinks) {
          options.editor.view.dispatch(tr);
          return true;
        }

        return false;
      }
    }
  });
}

var Link = Mark.create({
  name: 'link',
  priority: 1000,
  keepOnSplit: false,
  onCreate: function onCreate() {
    this.options.protocols.forEach(function (protocol) {
      if (typeof protocol === 'string') {
        registerCustomProtocol(protocol);
        return;
      }

      registerCustomProtocol(protocol.scheme, protocol.optionalSlashes);
    });
  },
  onDestroy: function onDestroy() {
    reset();
  },
  inclusive: function inclusive() {
    return this.options.autolink;
  },
  addOptions: function addOptions() {
    return {
      openOnClick: true,
      linkOnPaste: true,
      autolink: true,
      protocols: [],
      HTMLAttributes: {
        target: '_blank',
        rel: 'noopener noreferrer nofollow',
        class: null
      },
      validate: undefined
    };
  },
  addAttributes: function addAttributes() {
    return {
      href: {
        default: null
      },
      target: {
        default: this.options.HTMLAttributes.target
      },
      rel: {
        default: this.options.HTMLAttributes.rel
      },
      class: {
        default: this.options.HTMLAttributes.class
      }
    };
  },
  parseHTML: function parseHTML() {
    return [{
      tag: 'a[href]:not([href *= "javascript:" i])'
    }];
  },
  renderHTML: function renderHTML(_ref2) {
    var HTMLAttributes = _ref2.HTMLAttributes;
    return ['a', mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0];
  },
  addCommands: function addCommands() {
    var _this = this;

    return {
      setLink: function setLink(attributes) {
        return function (_ref3) {
          var chain = _ref3.chain;
          return chain().setMark(_this.name, attributes).setMeta('preventAutolink', true).run();
        };
      },
      toggleLink: function toggleLink(attributes) {
        return function (_ref4) {
          var chain = _ref4.chain;
          return chain().toggleMark(_this.name, attributes, {
            extendEmptyMarkRange: true
          }).setMeta('preventAutolink', true).run();
        };
      },
      unsetLink: function unsetLink() {
        return function (_ref5) {
          var chain = _ref5.chain;
          return chain().unsetMark(_this.name, {
            extendEmptyMarkRange: true
          }).setMeta('preventAutolink', true).run();
        };
      }
    };
  },
  addProseMirrorPlugins: function addProseMirrorPlugins() {
    var plugins = [];

    if (this.options.autolink) {
      plugins.push(autolink({
        type: this.type,
        validate: this.options.validate
      }));
    }

    if (this.options.openOnClick) {
      plugins.push(clickHandler({
        type: this.type
      }));
    }

    plugins.push(pasteHandler({
      editor: this.editor,
      type: this.type,
      linkOnPaste: this.options.linkOnPaste
    }));
    return plugins;
  }
});
export { Link, Link as default };